import { useState, useEffect } from 'preact/hooks';

// eslint-disable-next-line import/prefer-default-export
export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const handleSize = () => {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  };
  useEffect(() => {
    handleSize();
    window.addEventListener('resize', handleSize);
    return () => window.removeEventListener('resize', handleSize);
  }, []);
  return {
    ...windowSize,
    isMobile: windowSize.width <= 689,
    isTablet: windowSize.width <= 1023,
  };
}
